import i18n from 'i18next';

const { UI } = Mobi2Go;
const { Order } = Mobi2Go;

UI.View({
    name: 'order_tip',
    model: Order,
    el: '[data-view="order-tip"]',
    model_listeners: {
        updateTip(tip) {
            if (tip.toFloat()) {
                this.$el.removeClass('m2g-hidden');
            } else {
                this.$el.addClass('m2g-hidden');
            }
            this.jQuery('[data-total]').html(
                i18n.t('common:price', { price: tip.getListPrice() })
            );
        },
    },
    initialise() {
        this.$el.localize();
    },
});
